import { Target } from '@nirvana/shared/dtos/types/dashboards/common';
import { TimeRange, TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { Filter } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { IntConditions, StringConditions } from '@nirvana/shared/dtos/types/shared/filters';
import {
  CompanyFilterDashboardDataProvider
} from '../../ui/gzSingleSelectComplex/dataProvider/company/CompanyFilterDashboardDataProvider';
import { longToNumber } from '@nirvana/shared/basic-types/long';

export async function getExecutiveSummaryParams(filters: Filter[]): Promise<{ selectedTarget: Target, timeRange: TimeRange }> {
  const companyId = (filters.find(filter => !!filter.company)?.company as StringConditions)?.equals;
  if (!companyId) {
    throw new Error('Undefined companyId.');
  }
  const companyName = await CompanyFilterDashboardDataProvider.getCompanyNameById(companyId);
  const selectedTarget = { companyId: companyId, companyName: companyName };

  const lastNumDays = (filters.find(filter => !!filter.lastSeen)?.lastSeen as IntConditions)?.equals;
  if (!lastNumDays) {
    throw new Error('Undefined lastNumDays.');
  }
  const timeRange: TimeRange = {
    kind: TimeRangeKind.RELATIVE_TIME_RANGE,
    relative: {
      lastNumDays: typeof lastNumDays === 'object'
        ? longToNumber(lastNumDays)
        : lastNumDays
    }
  };

  return { selectedTarget, timeRange };
}

